import React from 'react';
import { NotFound } from '../../components/NotFound';
import { PaymentStatus } from '../../components/PaymentStatus';
import { useStatusPurchase } from '../../shared/use-status-purchase';
import { useDocumentTitle } from '../../shared/use-document-title';
import { useRouting } from '../../shared/use-routing';
import { getSubscriptionStatus } from '../../../lib/use-cases/get-subscription-status';
import { useUser } from '../../shared/use-user';
import { useAuthentication } from '../../shared/use-authentication';

function SubscriptionStatusPage() {
    const {userData} = useUser();
    const {signInBySubscription} = useAuthentication();
    const {params: {subscriptionId}} = useRouting();

    const {purchaseData, isLoading} = useStatusPurchase({
        id: subscriptionId,
        getStatus: getSubscriptionStatus
    });

    useDocumentTitle('Subscription Status');

    if (!subscriptionId || (!isLoading && !purchaseData.plan)) {
        return <NotFound />;
    };

    return (
        <PaymentStatus
            data={purchaseData}
            subscriptionId={subscriptionId}
            signIn={signInBySubscription}
            userData={userData}
        />
    )
}

export {
    SubscriptionStatusPage
}
